export default {
	state: {
		taxData: [],
	},

	mutations: {
		setTaxData(state, taxData) {
			state.taxData = taxData;
		}
	},

	actions: {
		getTaxData(context) {
			const { rootState } = context;

			const currentLpo = rootState.lpoData.currentLpo;

			// console.log('get tax data: ', currentLpo);
		}
	}
};